import {
  clearSelection,
  hasSelection,
  selectedEvents,
  selectedGroupKeys,
  selectedRange,
  selectedRanges,
} from '../store/selectionStore';
import { debug } from './console';

/**
 * True when the page holds an active maneuver selection: clicked table/map rows, a brush range,
 * or a colour-legend group.
 *
 * `selection` is deliberately not consulted - each page's filterData() fills it with every
 * filtered event id whenever nothing is selected, so it is never a "the user picked something"
 * signal.
 */
export function hasActiveManeuverSelection(): boolean {
  return (
    hasSelection() ||
    selectedEvents().length > 0 ||
    selectedRange().length > 0 ||
    selectedRanges().length > 0 ||
    selectedGroupKeys().length > 0
  );
}

/**
 * Drop the active selection when the maneuver type changes.
 *
 * A different type is a different set of events, so a selection carried across the switch points
 * at rows that are no longer in the table while the map and timeseries keep drawing the old
 * type's tracks. Cuts and filters are left alone - only the selection goes.
 *
 * `immediate` so the clear lands before the page's refetch instead of in a setTimeout after it.
 */
export function clearManeuverSelectionOnEventTypeChange(pageName: string): void {
  if (!hasActiveManeuverSelection()) return;
  debug(`${pageName}: maneuver type changed - cleared selection`);
  clearSelection({ preserveFilters: true, immediate: true });
}
